import React from 'react';
import {
    fabric
} from 'fabric';

import nodesjson from '../nodes.json';
import updatelinksjson from '../link_updates.json';
import stylesjson from '../styles.json';

const HEADER_HEIGHT = 50;
const FIELD_HEIGHT = 30;
const SBODY_WIDTH = 150;
const ADJUST = 10; 
const GAP = 20; //for gap between objects
const LEFT_RIGHT = "LR";
const TOP_BOTTOM = "TB";
const LINE_REVERSE = 'REVERSE';

// https://imagecolorpicker.com/en/

class FabricCanvas extends React.Component {

    collapseIcon = null;
    expandIcon = null;
    appSettings = {};
    fontopt = {};
    nodeheaderopt = {};
    schemaheaderopt = {};
    schemaboxopt = {};
    nodebodyboxopt = {};
    fieldopt = {};
    lineopt = {};
    arrowopt = {};
    selectedObject = null;
    isAnimating = false;
    direction = TOP_BOTTOM;
    xLimit = 300;
    yLimit = 100;
    rects = [];
    trycount = 0;

    constructor(props, context) {
        super(props);
        this.updateLinks = this.updateLinks.bind(this);        
        this.fitToScreen = this.fitToScreen.bind(this);
    }

    componentDidMount() {

        var self = this;

        fabric.Object.prototype.objectCaching = false;
        fabric.Object.prototype.statefullCache = false;
        fabric.Object.prototype.noScaleCache = true;
        //fabric.Object.prototype.needsItsOwnCache = false;
        fabric.Object.prototype.originX = 'center';
        fabric.Object.prototype.originY = 'center';
        fabric.Object.prototype.hasControls = false;
        fabric.Object.prototype.hasBorders = false;
        fabric.Object.prototype.hasRotatingPoint = false;
        fabric.Object.prototype.selectable = false;
        fabric.Object.prototype.lockMovementX = true;
        fabric.Object.prototype.lockMovementY = true;

        // Make a New Canvas
        this.canvas = new fabric.Canvas('main-canvas', {
            preserveObjectStacking: true,
            width: window.innerWidth,
            height: window.innerHeight,
            selection: false,
            skipTargetFind: false,
            renderOnAddRemove: false,
        });

        this.appSettings = stylesjson.appSettings;
        
        this.direction = this.appSettings.direction;

        this.fontopt = stylesjson.fontopt;
        this.nodeheaderopt = stylesjson.nodeheaderopt;
        this.schemaheaderopt = stylesjson.schemaheaderopt;
        this.schemaboxopt = stylesjson.schemaboxopt;
        this.nodebodyboxopt = stylesjson.nodebodyboxopt;
        this.fieldopt = stylesjson.fieldopt;
        this.lineopt = stylesjson.lineopt;
        this.arrowopt = stylesjson.arrowopt;

        this.initIcons();

        nodesjson.links.forEach(function(node, index) {

            //create data source nodes 
            //create schemas
            //create all field nodes

            self.processNode(node);
        });

        this.updateSchemaSizeAndPosition();
        
        this.arrangeDS();

        // create connections between schemas
        // create connection for data source nodes

        this.fitDiagram();
        
        this.createConnectionLinks();

        this.initCanvasEvents();

        this.canvas.toggleDragMode(true);

        this.canvas.renderAll();
    }

    updateSchemaSizeAndPosition() {

        var dsobjects = this.findObjsByType('dsi');

        for (var d = 0; d < dsobjects.length; d++) {
            //dsobject - ds obj - dsi
            var dsobject = dsobjects[d];
            
            var dsheader = dsobject.getObjects()[0];
            var dsbody = dsobject.getObjects()[1];
            var sobjs = dsbody.ss;

            for (var s = 0; s < sobjs.length; s++) {
                //sobject - s obj - si
                var sobject = sobjs[s];
                var sheader = sobject.getObjects()[0];

                sobject.left = dsobject.left;
                sobject.top = dsobject.top + ADJUST;
                sobject.setCoords();

                var sbody = sobject.getObjects()[1];
                var fobjs = sbody.sfs;

                //iterate fobjs tp find order of close schemas and find order of close data sources
                let tdsimap = new Map();
                let tsimap = new Map();
                for (var f = 0; f < fobjs.length; f++) {
                    var fobject = fobjs[f];
                    
                    fobject.tdsis.forEach(function(tdsi, index) {
                        if(tdsimap.has(tdsi)) {
                            var val = tdsimap.get(tdsi);
                            tdsimap.set(tdsi, val+1);
                        } else {
                            tdsimap.set(tdsi, 1);
                        }
                    });
                    fobject.tsis.forEach(function(tsi, index) {
                        if(tsimap.has(tsi)) {
                            var val = tsimap.get(tsi);
                            tsimap.set(tsi, val+1);
                        } else {
                            tsimap.set(tsi, 1);
                        }
                    });
                }
                //sort by descending
                tdsimap = new Map([...tdsimap.entries()].sort((a,b) => b[1] - a[1]));
                tsimap = new Map([...tsimap.entries()].sort((a,b) => b[1] - a[1]));

                sobject.tsimap = tsimap;
                dsobject.tdsimap = tdsimap;

                sbody.oldheight = sbody.height;
                sbody.height = FIELD_HEIGHT * fobjs.length;
                sheader.top -= (sbody.height - sbody.oldheight)/2;
                sbody.setCoords();
                
                sobject.height = sbody.height + HEADER_HEIGHT;
            }
            sobject.setCoords();

            var processedSIDs = [];
            var updatedSIDs = [];
            var lastLeft = 0;
            var lastTop = 0;
            for (var s = 0; s < sobjs.length; s++) {
                var sobject = sobjs[s];

                var totalHeight = 0;
                var totalWidth = 0;
                //key, value
                for (const [tsid, count] of sobject.tsimap.entries()) {
                  var validSize = false;
                  if(sobject.tsimap.size > 1 && count > 1)  validSize = true;
                  if(sobject.tsimap.size < 1 && count < 1) validSize = true;
                  if(validSize && processedSIDs.includes(tsid) === false && sobject.si != tsid) {
                    //get total height of schemas
                    var psobj = this.findObj('si', tsid, sobjs);

                    if(this.direction == LEFT_RIGHT) {
                        psobj.left = sobject.left + sobject.width + GAP;
                        lastLeft = psobj.left;                        
                    } else {
                        psobj.top = sobject.top + sobject.height + GAP;
                        lastTop = psobj.top;
                    }

                    //check if overlaps 
                    //https://www.geeksforgeeks.org/find-two-rectangles-overlap/
                    //https://stackoverflow.com/questions/306316/determine-if-two-rectangles-overlap-each-other

                    psobj.setCoords();
                    totalWidth += psobj.width;
                    totalHeight += psobj.height + GAP;

                    if (updatedSIDs.includes(sobject.si) === false) {
                        updatedSIDs.push(sobject.si);
                    }
                    if (updatedSIDs.includes(tsid) === false) {
                        updatedSIDs.push(tsid);
                    }
                  }
                }

                var tempTop = 0;
                var tempLeft = 0;
                if(totalHeight || totalWidth)
                for (const [tsid, count] of sobject.tsimap.entries()) {  
                  var validSize = false;
                  if(sobject.tsimap.size > 1 && count > 1)  validSize = true;
                  if(sobject.tsimap.size < 1 && count < 1)  validSize = true;
                  if(validSize && processedSIDs.includes(tsid) === false && sobject.si != tsid) {
                    //get total height of schemas
                    var psobj = this.findObj('si', tsid, sobjs);
                    if(this.direction == LEFT_RIGHT) {
                        if(tempTop) {
                            psobj.top = tempTop + ADJUST + psobj.height/2;
                        } else {
                            psobj.top =  sobject.top - (totalHeight/2) + psobj.height/2;   
                        }
                        tempTop = psobj.top + psobj.height/2;
                    } else {
                        if(tempLeft) {
                            psobj.left = tempLeft + ADJUST + psobj.width/2;
                        } else {
                            psobj.left =  sobject.left - (totalWidth/2) + psobj.width/2;   
                        }
                        tempLeft = psobj.left + psobj.width/2;
                    }
                    psobj.setCoords();
                  }
                }

                if (processedSIDs.includes(sobject.si) === false) {
                    processedSIDs.push(sobject.si);
                }

                if (updatedSIDs.includes(sobject.si) === false) {                    
                    var psobj = this.findObj('si', sobject.si, sobjs);
                    if(this.direction == LEFT_RIGHT) {
                        psobj.left = lastLeft + sobject.width + GAP;       
                        lastLeft = psobj.left;
                    } else {
                        psobj.top = lastTop + sobject.height + GAP;       
                        lastTop = psobj.top;
                    }
                    psobj.setCoords();
                    updatedSIDs.push(sobject.si);
                }
                
                this.updatefobjspostion(sobject);
            }
        }
    }

    updatefobjspostion(sobject) {
                
        sobject.setCoords();
        var sbody = sobject.getObjects()[1];
        var fobjs = sbody.sfs;
        for (var f = 0; f < fobjs.length; f++) {
            //fobject - f obj - fi
            var fobject = fobjs[f];
            this.canvas.bringToFront(fobject);
            fobject.left = sobject.left;
            fobject.top = sobject.top - sobject.height/2 + HEADER_HEIGHT + FIELD_HEIGHT * f + ADJUST;
            fobject.setCoords();
        }
    }

    //arrange data source
    arrangeDS(isUpdateLeft=true) {

        var forObj = this.selectedObject;

        var dsobjects = this.findObjsByType('dsi');

        //arrange data source objects based on the close connections
        for (var d = 0; d < dsobjects.length; d++) {
            var dsobject = dsobjects[d];

            var dsheader = dsobject.getObjects()[0];
            var dsbody = dsobject.getObjects()[1];
            var sobjs = dsbody.ss;

            var selobjs = [];
            for (var s = 0; s < sobjs.length; s++) {
                var sobject = sobjs[s];
                var sheader = sobject.getObjects()[0];
                var sbody = sobject.getObjects()[1];

                if(sobject.visible)
                selobjs.push(sobject);

                var fobjs = sbody.sfs;
                for (var f = 0; f < fobjs.length; f++) {
                    //fobject - f obj - fi
                    var fobject = fobjs[f];
                    if(fobject.visible)
                    selobjs.push(fobject);
                }
            }

            var sel = new fabric.ActiveSelection(selobjs);

            if(sel.width === 0) sel.width = SBODY_WIDTH;

            dsbody.oldwidth = dsbody.width;
            dsbody.width = sel.width;            
            dsheader.getObjects()[0].width = sel.width;
            dsobject.width = sel.width;

            dsbody.oldheight = dsbody.height;
            dsbody.height = sel.height;

            dsheader.top = dsbody.top - dsbody.height/2 - HEADER_HEIGHT/2;
            dsbody.setCoords();

            if(sel.height>0)
            dsobject.height += dsbody.height - dsbody.oldheight;
            
            dsobject.setCoords();

            if(isUpdateLeft)
                this.placeDS(dsobject);
            
            sel.left = dsobject.left;
            sel.top = dsobject.top + HEADER_HEIGHT/2;

            sel.setCoords();
            dsobject.setCoords();

            sel.destroy();

            this.canvas.discardActiveObject();
            this.canvas.requestRenderAll();
        }
    }

    //https://stackoverflow.com/questions/43424770/onclick-create-random-rectangle-in-canvas-that-wont-collide-with-existing-ones
    placeDS(dsobject) {
        
        var self = this;
        var coordx = Math.random() * this.xLimit;
        var coordy = Math.random() * this.yLimit;
        var width = dsobject.width;
        var height = dsobject.height;

        var rect = {
            x: coordx - 10,
            y: coordy - 10,
            w: width + 10,
            h: height + 10
        }

        var ok = true;
        this.rects.forEach(function (item) {
            if (self.isCollide(rect, item)) {
                ok = false;
            } else {
                console.log("no collision");
            }
        })

        if (ok) {
            dsobject.left = coordx + width/2;
            dsobject.top = coordy + height/2;
            dsobject.setCoords();
            this.rects.push(rect);        
            this.trycount = 0;
        } else {
            if(this.trycount > 10) {
                this.xLimit += 50;
                this.yLimit += 50;
                this.trycount = 0;
            }
            this.trycount++;
            this.placeDS(dsobject);
        }
    }

    isCollide(a, b) {
        return !(
            ((a.y + a.h) < (b.y)) ||
            (a.y > (b.y + b.h)) ||
            ((a.x + a.w) < b.x) ||
            (a.x > (b.x + b.w))
        );
    }
    
    createConnectionLinks(isUpdate=false) {

        var self = this;

        nodesjson.links.forEach(function(node, index) {            
            var fobj1 = self.findObj('fi', node.source_field_id);
            var fobj2 = self.findObj('fi', node.target_field_id);
            self.drawLine(fobj1, fobj2);
        });

        if(isUpdate)
        updatelinksjson.links.forEach(function(node, index) {            
            var fobj1 = self.findObj('fi', node.source_field_id);
            var fobj2 = self.findObj('fi', node.target_field_id);
            self.drawLine(fobj1, fobj2);
        });
    }
    
    updateConnectionLinks() {
        //remove
        var objects = this.canvas.getObjects();

        objects = objects.filter(function(o) {
            return (o.type === 'path');
        });

        for (var l = 0; l < objects.length; l++) {
            if(objects[l].arrow)
                this.canvas.remove(objects[l].arrow);
            this.canvas.remove(objects[l]);
        }
        var dsobjects = this.findObjsByType('dsi');
        for (var d = 0; d < dsobjects.length; d++) {
            //dsobject - ds obj - dsi
            var dsobject = dsobjects[d];
            dsobject.lines = [];
            var dsbody = dsobject.getObjects()[1];
            var sobjs = dsbody.ss;

            for (var s = 0; s < sobjs.length; s++) {
                //sobject - s obj - si
                var sobject = sobjs[s];
                sobject.lines = [];
                var sbody = sobject.getObjects()[1];
                var fobjs = sbody.sfs;
                for (var f = 0; f < fobjs.length; f++) {
                    fobjs[f].lines = [];
                }
            }
        }
        this.canvas.renderAll();
        this.createConnectionLinks(true);
    }

    createLine(linearray) {
        
        var pathstring = "M " + linearray[0].x + " " + linearray[0].y + " C ";

        for (var i = 1; i < linearray.length; i++) {
            pathstring += linearray[i].x + " " + linearray[i].y + " ";
        }

        var path = new fabric.Path(pathstring, this.lineopt);

        this.canvas.add(path);

        var arrow = this.makeArrow(linearray[linearray.length-1].x, linearray[linearray.length-1].y);
        this.canvas.add(arrow);

        var dx = linearray[linearray.length-2].x - linearray[linearray.length-1].x;
        var dy = linearray[linearray.length-2].y - linearray[linearray.length-1].y;

        var angle = Math.atan2(dy, dx) * 180 / Math.PI;
        arrow.angle = angle + 270;

        arrow.setCoords();

        this.canvas.bringToFront(arrow);

        path.arrow = arrow;

        return path;
    }

    validateLineIntersect(linearray, fobj1, fobj2, x1, y1, x2, y2) {

        var dobj = this.findObj("dsi", fobj1.fdsi || fobj1.sdsi);
        var body = dobj.getObjects()[1];
        var sobjs = body.ss;
        var isIntersect = false;
        var lpos, lpos1, tpos, tpos1;

        if(sobjs)
        for (var s = 0; s < sobjs.length; s++) {
            var sobj = sobjs[s];

            if(sobj.si === fobj1.fsi || sobj.si === fobj2.fsi || sobj.si === fobj1.si || sobj.si === fobj2.si) {
            } else {
        
                //draw line
                var line = new fabric.Line([ x1, y1, x2, y2 ], {
                    left: x1+((x2-x1)/2),
                    top: y1,
                    stroke: 'green'
                });        
                this.canvas.add(line);
                line.setCoords();
                this.canvas.bringToFront(line);
                //check intersect
                if(line.intersectsWithObject(sobj)) {

                    lpos = sobj.left-sobj.width/2;
                    tpos = sobj.top+sobj.height/2+sobj.height/4;

                    if(fobj2.top < sobj.top) {
                        tpos = sobj.top-sobj.height/2-sobj.height/4;
                    }

                    if(fobj1.left > fobj2.left) {
                        lpos = sobj.left+sobj.width/2;
                        lpos1 = sobj.left-sobj.width/2;
                    }
                    
                    linearray.push({"x": x1,"y": y1});
                    linearray.push({"x": lpos,"y": tpos});

                    isIntersect = true;
                }
                this.canvas.remove(line);
            }
        }        
        if(isIntersect) {
            //this.validateLineIntersect(linearray, fobj1, fobj2, lpos, tpos, x2, tpos);
        } else {
            linearray.push({"x": x2,"y": y2});
        }
    }

    getRandomInt(min, max) {
      return Math.random() * (max - min) + min;
    }

    generateLinePoints(o1, o2) {

        var linearray = [];
        var lineflow = 'FORWARD';

        if(this.direction === LEFT_RIGHT) {
            var o1left = o1.left + (o1.width/2);
            var o2left = o2.left - (o2.width/2) - this.arrowopt.width/2;

            var o1top = o1.top;
            var o2top = o2.top;

            if(o1.left > o2.left) {
                o1left = o1.left - (o1.width/2);
                o2left = o2.left + (o2.width/2) + this.arrowopt.width/2;
                lineflow = LINE_REVERSE;
            }
            
            var cp = o2left - o2.width/2;
            if(o2.si) {
                cp = o2left - o2.width/4;
            }
            
            if(o2left < o1left) {
                cp = o2left + o2.width/2;
                if(o2.si) {
                    cp = o2left + o2.width/4;
                }
            }

            var randtop1 = this.getRandomInt(o1top-o1.height/2+this.arrowopt.width/2, o1top+o1.height/2-this.arrowopt.width/2);
            var randtop2 = this.getRandomInt(o2top-o2.height/2+this.arrowopt.width/2, o2top+o2.height/2-this.arrowopt.width/2);

            var cptop = randtop1 + (randtop2-randtop1)/2;
            var cpleft = o1left + (o2left-o1left)/2;
            
            if(randtop2 < randtop1) {
                cptop = randtop2 + (randtop1-randtop2)/2;
            }            
            if(o2left < o1left) {
                cpleft = o2left + (o1left-o2left)/2;
            }         
            
            linearray.push({"x": o1left,"y": randtop1});

            this.validateLineIntersect(linearray, o1, o2, o1left, randtop1, cpleft, cptop);

            //linearray.push({"x": cpleft,"y": cptop});

            var adjtop = randtop2;
            if(linearray[linearray.length-1].y < randtop2)
                adjtop -= o2.height/2;
            if(linearray[linearray.length-1].y > randtop2)
                adjtop += o2.height/2;

            if(linearray.length == 2)
            linearray.push({"x": cp,"y": adjtop});
        
            linearray.push({"x": o2left,"y": randtop2});
        } else {

            var o1top = o1.top - o1.height/2 + o1.los;
            var o2top = o2.top + o2.height/2 + o2.los;

            if(o1.top > o2.top) {
                o1top = o1.top - (o1.height/2);
                o2top = o2.top + (o2.height/2);
            }
            var cp = o1top + (o2top - o1top)/2;

            var o1left = o1.left + (o1.width/2);
            var o2left = o2.left + (o2.width/2);
            var o1leftw = o1left+o1.width/2;
            var o2leftw = o2left+o2.width/2;

            if(o2.left < o1.left) {
                o1left = o1.left - (o1.width/2);
                o2left = o2.left - (o2.width/2);
                o1leftw = o1left-o1.width/2;
                o2leftw = o2left-o2.width/2;
                lineflow = LINE_REVERSE;
            }

            linearray.push({"x": o1left,"y": o1top});
            linearray.push({"x": o1leftw,"y": o1top});
            linearray.push({"x": o1leftw,"y": cp});
            linearray.push({"x": o2leftw,"y": cp});
            linearray.push({"x": o2leftw,"y": o2top});
            linearray.push({"x": o2left,"y": o2top});
        }

        return {linearray, lineflow}
    }

    drawLine(o1, o2) {

        if(!o1 || !o2) return false;

        if(!o1.visible) {
            o1 = this.findObj("si", o1.fsi);
            if(!o1.visible)
                o1 = this.findObj("dsi", o1.sdsi);
        }
        if(!o2.visible) {
            o2 = this.findObj("si", o2.fsi);
            if(!o2.visible)
                o2 = this.findObj("dsi", o2.sdsi);
        }

        if(o1.dsi && o2.dsi && o1.dsi === o2.dsi) return false;

        if(o1.collapsed && o2.collapsed) {
            if(o1.lines)
            for (var l = 0; l < o1.lines.length; l++) {
                var line = o1.lines[l];
                if(line.visible && line.o1.si && line.o1.si == o1.si && line.o2.si && line.o2.si == o2.si) {
                    return false;
                }
            }
        }

        var vals = this.generateLinePoints(o1, o2);
        var linearray = vals.linearray;
        var lineflow = vals.lineflow;

        var line = this.createLine(linearray);

        line.setCoords();

        line.lineflow = lineflow;

        this.canvas.bringToFront(line);
        this.canvas.bringToFront(line.arrow);

        line.o1 = o1;
        line.o2 = o2;

        if(!o1.lines) o1.lines = [];
        o1.lines.push(line);
        if(!o2.lines) o2.lines = [];
        o2.lines.push(line);
    }

    makeArrow(left, top) {
        var c = new fabric.Triangle(this.arrowopt);

        c.left = left;
        c.top = top;
        c.angle = 90;

        return c;
    }

    // Pass in the objects to merge as arguments.
    // For a deep extend, set the first argument to `true`.
    extendobject() {

        // Variables
        var extended = {};
        var deep = false;
        var i = 0;
        var length = arguments.length;

        // Check if a deep merge
        if ( Object.prototype.toString.call( arguments[0] ) === '[object Boolean]' ) {
            deep = arguments[0];
            i++;
        }

        // Merge the object into the extended object
        var merge = function (obj) {
            for ( var prop in obj ) {
                if ( Object.prototype.hasOwnProperty.call( obj, prop ) ) {
                    // If deep merge and property is an object, merge properties
                    if ( deep && Object.prototype.toString.call(obj[prop]) === '[object Object]' ) {
                        extended[prop] = this.extendobject( true, extended[prop], obj[prop] );
                    } else {
                        extended[prop] = obj[prop];
                    }
                }
            }
        };

        // Loop through each object and conduct a merge
        for ( ; i < length; i++ ) {
            var obj = arguments[i];
            merge(obj);
        }

        return extended;

    };

    findObj(type, value, gobjs) {

        if(!gobjs)
            gobjs = this.canvas.getObjects();

        var objs = gobjs.filter(function(o) {
            return (o[type] === value);
        });

        return objs[0];
    }

    findObjsByType(type) {

        var objects = this.canvas.getObjects();

        objects = objects.filter(function(o) {
            return (o[type] !== undefined);
        });

        return objects;
    }

    initIcons() {

        var self = this;

        var mimgurl = require('../images/minus.png');
        fabric.Image.fromURL(mimgurl, (img) => {
            img.set({
                opacity: 0,
                selectable: true,
                hoverCursor: "pointer"
            });
            img.scaleToWidth(30);
            img.src = mimgurl;
            img.icon = "collapse";
            self.collapseIcon = img;
            self.canvas.add(self.collapseIcon);
            self.collapseIcon.setCoords();
            self.canvas.renderAll();
        });

        var pimgurl = require('../images/plus.png');
        fabric.Image.fromURL(pimgurl, (img) => {
            img.set({
                opacity: 0,
                selectable: true,
                hoverCursor: "pointer"
            });
            img.scaleToWidth(30);
            img.src = pimgurl;
            img.icon = "expand";
            self.expandIcon = img;
            self.canvas.add(self.expandIcon);
            self.expandIcon.setCoords();
            self.canvas.renderAll();
        });
    }

    updatefielddata(node, fobj) {
        if(!fobj.tdsis) 
            fobj.tdsis = [];
        if(node.source_data_store_id != node.target_data_store_id && fobj.tdsis.includes(node.target_data_store_id) === false) {
            fobj.tdsis.push(node.target_data_store_id);
        }
        if(!fobj.tsis) 
            fobj.tsis = [];
        if (fobj.tsis.includes(node.target_schema_id) === false)
            fobj.tsis.push(node.target_schema_id);        
    }
    
    //fi - field id
    //fn - field name
    createField(node, dsi, si, fi, fn, sfs) {        
        var fobj = this.findObj('fi', fi, sfs);
        if(fobj) {     
            this.updatefielddata(node, fobj);
            return false;
        } else {
            var sfbox = new fabric.Rect(this.fieldopt);
            var sftext = new fabric.Textbox('Field ' + fi + ': ' + fn, this.fontopt);
        
            var sf = new fabric.Group([ sfbox, sftext ]);
            sf.fi = fi;
            sf.fsi = si;
            sf.fdsi = dsi;

            this.updatefielddata(node, sf);
            return sf;
        }
    }

    //si - schema id
    //sn - schema name
    createSchemaHeader(si, sn) {

        var sheaderbox = new fabric.Rect(this.schemaheaderopt);
        var sheadertext = new fabric.Textbox('Schema '+si+': '+sn, this.fontopt);
        var sheader = new fabric.Group([ sheaderbox, sheadertext ], { top: -HEADER_HEIGHT });
        return sheader;
    }

    createNewSchema(node, dsi, si, sn, fi, fn) {

        //schema1
        //schema header
        var sheader = this.createSchemaHeader(si, sn);

        if(sheader) {

            //schema 1 body
            var sf = this.createField(node, dsi, si, fi, fn);

            if(sf) {
                var sbody = new fabric.Rect(this.schemaboxopt);

                var schema = new fabric.Group([ sheader, sbody ]);
                schema.si = si;
                schema.sdsi = dsi;

                this.canvas.add(sf);

                if(sbody.sfs) {
                    sbody.sfs.push(sf);
                } else {
                    sbody.sfs = []; 
                    sbody.sfs.push(sf);
                } 
            }
        }

        return schema;
    }

    // si - source id
    // sn - source name
    // fi - field id
    // fn - field name
    createSchema(node, dsi, si, sn, fi, fn, ss) {
        
        var sobj = this.findObj('si', si, ss);
        if(sobj) {  
            var sbody = sobj.getObjects()[1];   
            var sf = this.createField(node, dsi, si, fi, fn, sbody.sfs);
            if(sf) {
                this.canvas.add(sf);

                if(sbody.sfs) {
                    sbody.sfs.push(sf);
                } else {
                    sbody.sfs = []; 
                    sbody.sfs.push(sf);
                } 
            }
            return false;

        } else {
            return this.createNewSchema(node, dsi, si, sn, fi, fn);
        }
    }

    //dsn - data store name
    //dsi - data store id
    createDSNodeHeader(dsi, dsn) {

        var headerbox = new fabric.Rect(this.nodeheaderopt);
        var headertext = new fabric.Textbox('Data Store '+ dsi+': '+dsn, this.fontopt);
        var nodeheader = new fabric.Group([ headerbox, headertext ], { top: -125 });
        return nodeheader;
    }

    createNewDSNode(node, dsi, dsn, si, sn, fi, fn) {
        
        var nodeheader = this.createDSNodeHeader(dsi, dsn);

        if(nodeheader) {

            var schema = this.createSchema(node, dsi, si, sn, fi, fn);

            var nodebody = new fabric.Rect(this.nodebodyboxopt);

            if(nodebody) {

                var nodeobj = new fabric.Group([ nodeheader, nodebody ], { left: 200, top: 300 });
                nodeobj.dsi = dsi;

                this.canvas.add(nodeobj);

                if(schema) {                    
                    this.canvas.add(schema);
                    if(!nodebody.ss) nodebody.ss = [];
                    nodebody.ss.push(schema);
                }
            }
        }

    }

    createDSNode(node, dsi, dsn, si, sn, fi, fn) {
        
        var nobj = this.findObj('dsi', dsi);

        if(nobj) {
            
            var nodebody = nobj.getObjects()[1];

            var schema = this.createSchema(node, dsi, si, sn, fi, fn, nodebody.ss);
            
            if(schema) {

                this.canvas.add(schema);
                if(!nodebody.ss) nodebody.ss = [];
                nodebody.ss.push(schema);
            }
        } else {
            this.createNewDSNode(node, dsi, dsn, si, sn, fi, fn);
        }

    }

    processNode(node) {
        
        this.createDSNode(node, node.source_data_store_id, node.source_data_store_name, node.source_schema_id, node.source_schema_name, node.source_field_id, node.source_field_name);
        this.createDSNode(node, node.target_data_store_id, node.target_data_store_name, node.target_schema_id, node.target_schema_name, node.target_field_id, node.target_field_name);
    }

    animateZoom(startV, endV, pX, pY) {

        //var self = this;
            
        this.canvas.zoomToPoint({ x: pX, y: pY }, endV);
        this.canvas.renderAll();

        /*fabric.util.animate({
          startValue: startV,
          endValue: endV,
          duration: 100,
          onChange: function(zoomvalue) {
            self.canvas.zoomToPoint({ x: pX, y: pY }, zoomvalue);
            self.canvas.renderAll();
          },
          onComplete: function() {
              self.canvas.renderAll();
          }
        });*/        
    }

    focus(line, isFocus) {
       
        var color = 'black';
        var opacity = 0.2;
        var strokeWidth = 1;
        var strokeDashArray = [0,0];
        if(isFocus) {
           color = 'red';
           opacity = 1;
           strokeWidth = 1.5;
           strokeDashArray = [0, 0];
        }

        line.stroke = color;
        line.strokeDashArray = strokeDashArray;
        line.strokeWidth = strokeWidth;
        line.opacity = opacity;
        this.canvas.bringToFront(line);
        line.arrow.fill = color;
        line.arrow.opacity = opacity;
        line.arrow.stroke = color;
        line.arrow.strokeWidth = strokeWidth;
        if(isFocus) {
            this.canvas.bringToFront(line);
            this.canvas.bringToFront(line.arrow);
        }
        
    }

    initCanvasEvents() {
        var self = this;

        this.canvas.__eventListeners = {};

        this.canvas.on('mouse:wheel', function(opt) {
            var delta = opt.e.deltaY;
            var oldzoom = self.canvas.getZoom();
            var newzoom = oldzoom - delta/300;
            if (newzoom > 5) newzoom = 5;
            if (newzoom < 0.1) newzoom = 0.1;

            self.animateZoom(oldzoom, newzoom, opt.e.offsetX, opt.e.offsetY);

            opt.e.preventDefault();
            opt.e.stopPropagation();
        })

        this.canvas.on('mouse:out', function(e) {
            var object = e.target;

            if(object && object.dsi) {

                var body = object.getObjects()[1];
                var sobjs = body.ss;

                if(object.lines)
                for (var l = 0; l < object.lines.length; l++) {
                    var line = object.lines[l];
                    self.focus(line, false);
                }

                for (var s = 0; s < sobjs.length; s++) {
                    var sobj = sobjs[s];

                    var sbody = sobj.getObjects()[1];
                    var fobjs = sbody.sfs;

                    for (var f = 0; f < fobjs.length; f++) {
                        if(fobjs[f].lines)
                        for (var l = 0; l < fobjs[f].lines.length; l++) {
                            var line = fobjs[f].lines[l];
                            self.focus(line, false);                            
                        }
                        self.canvas.renderAll();
                    }
                }
            }
            if(object && object.si) {

                var sbody = object.getObjects()[1];
                var fobjs = sbody.sfs;

                if(object.lines)
                for (var l = 0; l < object.lines.length; l++) {
                    var line = object.lines[l];
                    self.focus(line, false);
                }

                for (var f = 0; f < fobjs.length; f++) {
                    if(fobjs[f].lines)
                    for (var l = 0; l < fobjs[f].lines.length; l++) {
                        var line = fobjs[f].lines[l];
                        self.focus(line, false);
                    }
                    self.canvas.renderAll();
                }
            }
            if(object && object.fi) {
                if(object.lines)
                for (var l = 0; l < object.lines.length; l++) {
                    var line = object.lines[l];
                    self.focus(line, false);
                }
                self.canvas.renderAll();
            }
        })

        this.canvas.on('object:selected', function(e) {
            var object = e.target;
            if(object && object.icon)
                self.hideIcons();
            self.collapseOrExpand(object);
        })

        this.canvas.on('mouse:move', function(e) {
            var object = e.target;

            if(object && object.type === 'group') {
                var header = object.getObjects()[0];

                var point = self.getMouseCoords(e);                
                if(point.x >= object.left - object.width/2 
                && point.x <= object.left + object.width/2
                && point.y >= object.top - object.height/2
                && point.y <= object.top - object.height/2 + header.height)
                {
                    self.canvas.hoverCursor = 'pointer';
                } else {
                    self.canvas.hoverCursor = 'move';
                }
            } else {
                self.canvas.hoverCursor = 'move';
            }
        });

        this.canvas.on('mouse:over', function(e) {
            var object = e.target;
            if(object && object.dsi) {
                var body = object.getObjects()[1];
                var sobjs = body.ss;

                if(object.lines)
                for (var l = 0; l < object.lines.length; l++) {
                    var line = object.lines[l];
                    self.focus(line, true);
                }

                for (var s = 0; s < sobjs.length; s++) {
                    var sobj = sobjs[s];

                    var sbody = sobj.getObjects()[1];
                    var fobjs = sbody.sfs;

                    for (var f = 0; f < fobjs.length; f++) {
                        if(fobjs[f].lines)
                        for (var l = 0; l < fobjs[f].lines.length; l++) {
                            var line = fobjs[f].lines[l];
                            self.focus(line, true);
                        }
                        self.canvas.renderAll();
                    }
                }
            }
            if(object && object.si) {

                if(object.lines)
                for (var l = 0; l < object.lines.length; l++) {
                    var line = object.lines[l];
                    self.focus(line, true);
                }

                var sbody = object.getObjects()[1];
                var fobjs = sbody.sfs;

                for (var f = 0; f < fobjs.length; f++) {
                    if(fobjs[f].lines)
                    for (var l = 0; l < fobjs[f].lines.length; l++) {
                        var line = fobjs[f].lines[l];
                        self.focus(line, true);
                    }
                    self.canvas.renderAll();
                }
            } 
            if(object && object.fi) {
                if(object.lines)
                for (var l = 0; l < object.lines.length; l++) {
                    var line = object.lines[l];
                    self.focus(line, true);
                }
                self.canvas.renderAll();
            } 

            if(object && object.type === 'group' && !self.isAnimating) {
                var header = object.getObjects()[0];
                var body = object.getObjects()[1];
                if(header && header.type === 'group' && header.getObjects()[1].text)
                {
                    if(object.collapsed === 'undefined')
                        object.collapsed = false;
                    self.selectedObject = object;
                    self.showHideIcons();
                    self.canvas.discardActiveObject();
                }
            }
        })
    }
            
    getMouseCoords(event)
    {
        var pointer = this.canvas.getPointer(event.e);
        return pointer;
    }

    animateObject(object, property, value, offset=1) {
        var self = this;

        if(!object) return;

        if(!object.icon)
        this.isAnimating = true;
        
        object[property] = !value;

        if(object)
        object.animate(property,value, {
          duration: 100,
          onChange: this.canvas.renderAll.bind(this.canvas),
          onComplete: function() {
            object['visible'] = value;

            /*if(object.height > 0 && !object.icon && object.custype != 'line' && object.custype != 'arrow') {
                object.prevHeight = object.height;
                object.height = 0;       
            } else if(value && object.prevHeight) {
                object.height = object.prevHeight;
            }*/

            object.setCoords();

            self.canvas.renderAll();
          },
          easing: fabric.util.ease['easeInOutQuad']
        });
    }

    hideIcons() {
        if(this.collapseIcon)
        this.collapseIcon.opacity = 0;

        if(this.expandIcon)
        this.expandIcon.opacity = 0;
    }

    showHideIcons(iconObj) {

        if(iconObj && !iconObj.icon)
            return false;
        
        var forObj = this.selectedObject;

        if(!forObj) return;

        this.hideIcons();

        if(iconObj && iconObj.icon === 'collapse') {
            this.expandIcon.opacity = 1;
        } else if(iconObj && iconObj.icon === 'expand') {
            this.collapseIcon.opacity = 1;
        }

        if(!iconObj) {
            if(forObj.collapsed)
                iconObj = this.expandIcon;
            else
                iconObj = this.collapseIcon;
            if(iconObj) iconObj.opacity = 1;
        }

        if(this.expandIcon) {
            this.expandIcon.left = forObj.left - (forObj.width*forObj.scaleX)/2;
            this.expandIcon.top = forObj.top - (forObj.height*forObj.scaleY)/2;
            this.expandIcon.setCoords();            
            this.collapseIcon.left = forObj.left - (forObj.width*forObj.scaleX)/2;
            this.collapseIcon.top = forObj.top - (forObj.height*forObj.scaleY)/2;
            this.collapseIcon.setCoords();
        }

        this.canvas.bringToFront(iconObj);

        this.canvas.renderAll();
    }

    collapseOrExpand(iconObj) {

        if(iconObj && !iconObj.icon)
            return false;
        
        var forObj = this.selectedObject;

        if(!forObj) return;

        if(iconObj && iconObj.icon === 'collapse') {

            forObj.collapsed = true;

            var header = forObj.getObjects()[0];
            var body = forObj.getObjects()[1];

            header.prevTop = header.top;
            header.top += body.height/2;
            
            if(forObj.si)
            forObj.prevHeight = forObj.height;

            forObj.height = HEADER_HEIGHT;

            forObj.setCoords();
            this.animateObject(body, 'opacity', 0);

            var fobjs = body.sfs;
            if(fobjs)
            for (var f = 0; f < fobjs.length; f++) {
                this.animateObject(fobjs[f], 'opacity', 0, f);
            }

            var sobjs = body.ss;
            if(sobjs)
            for (var s = 0; s < sobjs.length; s++) {
                this.animateObject(sobjs[s], 'opacity', 0, s);

                var sbody = sobjs[s].getObjects()[1];
                fobjs = sbody.sfs;

                for (f = 0; f < fobjs.length; f++) {
                    fobjs[f].visible = false;
                    this.animateObject(fobjs[f], 'opacity', 0, f);
                    //hide all lines
                    if(fobjs[f].lines)
                    for (var l = 0; l < fobjs[f].lines.length; l++) {
                        var li = fobjs[f].lines[l];
                        if(li.o1.fdsi === li.o2.fdsi) {
                            this.animateObject(li, 'opacity', 0);
                            this.animateObject(li.arrow, 'opacity', 0);
                        }
                    }
                }

            }
        } else if(iconObj && iconObj.icon === 'expand') {
            
            forObj.collapsed = false;
            
            header = forObj.getObjects()[0];
            header.top = header.prevTop;

            body = forObj.getObjects()[1];

            if(forObj.si)
            forObj.height = forObj.prevHeight;
            
            forObj.setCoords();

            this.animateObject(body, 'opacity', 1);
               
            fobjs = body.sfs;
            if(fobjs) {
                this.updatefobjspostion(forObj);
                for (f = 0; f < fobjs.length; f++) {
                    this.animateObject(fobjs[f], 'opacity', 1, f);
                }
            }
            
            sobjs = body.ss;
            if(sobjs)
            for (s = 0; s < sobjs.length; s++) {
                this.animateObject(sobjs[s], 'opacity', 1, s);
                
                this.updatefobjspostion(sobjs[s]);

                sbody = sobjs[s].getObjects()[1];
                fobjs = sbody.sfs;
                if(!sobjs[s].collapsed) {
                    for (f = 0; f < fobjs.length; f++) {
                        this.animateObject(fobjs[f], 'opacity', 1, f);
                    }
                }
                for (f = 0; f < fobjs.length; f++) {
                    if(fobjs[f].lines)
                    for (var l = 0; l < fobjs[f].lines.length; l++) {
                        var li = fobjs[f].lines[l];
                        this.animateObject(li, 'opacity', 0.2);
                        this.animateObject(li.arrow, 'opacity', 0.2);
                        this.canvas.bringToFront(li.arrow);
                    }
                }
            }
        }

        var self = this;
        setTimeout(function() {
            self.arrangeDS(false);
            setTimeout(function() {
                self.updateConnectionLinks();
                self.canvas.renderAll();
                self.isAnimating = false;
            }, 10);
        }, 500);
    }

    updateLinks() {

        var self = this;
        this.xLimit = 300;
        this.yLimit = 100;
        this.rects = [];
        this.trycount = 0;

        this.canvas.clear();

        this.initIcons();

        var nodes = [];

        nodesjson.links.forEach(function(node, index) {
            self.processNode(node);
        });
        
        updatelinksjson.links.forEach(function(node, index) {
            self.processNode(node);
        });

        this.updateSchemaSizeAndPosition();

        this.arrangeDS();

        this.fitDiagram();

        this.createConnectionLinks(true);

        this.canvas.renderAll();
    }

    fitToScreen() {
        this.fitDiagram();
        this.updateConnectionLinks();
        this.canvas.renderAll();
    }

    fitDiagram() {

        this.hideIcons();

        //https://stackoverflow.com/questions/28863678/fabricjs-canvas-reset-after-zooming        
        this.canvas.setViewportTransform([1,0,0,1,0,0]); 

        this.canvas.discardActiveObject();

        var objects = this.canvas.getObjects();

        var objs = objects.filter(function(o) {
            o.setCoords();
            return !o.icon;
        });

        var actSel = new fabric.ActiveSelection(objs);

        this.canvas.setActiveObject(actSel);
        
        actSel.left = this.canvas.width/2;
        actSel.top = this.canvas.height/2;
        actSel.setCoords();

        var oldzoom = this.canvas.getZoom();
        var newzoom = (this.canvas.width - 50)/actSel.width;

        if(newzoom > (this.canvas.height - 50)/actSel.height)
            newzoom = (this.canvas.height - 50)/actSel.height;

        this.animateZoom(oldzoom, newzoom, this.canvas.width/2, this.canvas.height/2);

        actSel.setCoords();
    
        actSel.destroy();

        this.canvas.discardActiveObject();

        this.canvas.requestRenderAll();
    }

    render(){
        
        return (
         
        <div className="row">
           <button onClick={this.updateLinks}>Update Links</button>
           <button onClick={this.fitToScreen}>Fit To Screen</button>
           <div className="col-md-12 main-area">
              <div className= "main-canvas-container">
                 <canvas id= 'main-canvas'>
                 </canvas>
              </div>
           </div>
        </div>

        );
    }
}

const STATE_IDLE = 'idle';
const STATE_PANNING = 'panning';
fabric.Canvas.prototype.toggleDragMode = function(dragMode=true) {
  // Remember the previous X and Y coordinates for delta calculations
  let lastClientX;
  let lastClientY;
  // Keep track of the state
  let state = STATE_IDLE;
  // We're entering dragmode
  if (dragMode) {
    // Discard any active object
    this.discardActiveObject();
    // Set the cursor to 'move'
    this.defaultCursor = 'move';
    // Loop over all objects and disable events / selectable. We remember its value in a temp variable stored on each object
    this.forEachObject(function(object) {
      object.prevEvented = object.evented;
      object.prevSelectable = object.selectable;
      //object.evented = false;
      //object.selectable = false;
    });
    // Remove selection ability on the canvas
    this.selection = false;
    // When MouseUp fires, we set the state to idle
    this.on('mouse:up', function(e) {
      state = STATE_IDLE;
    });
    // When MouseDown fires, we set the state to panning
    this.on('mouse:down', (e) => {
      state = STATE_PANNING;
      lastClientX = e.e.clientX;
      lastClientY = e.e.clientY;
    });
    // When the mouse moves, and we're panning (mouse down), we continue
    this.on('mouse:move', (e) => {
      if (state === STATE_PANNING && e && e.e) {
        // let delta = new fabric.Point(e.e.movementX, e.e.movementY); // No Safari support for movementX and movementY
        // For cross-browser compatibility, I had to manually keep track of the delta

        // Calculate deltas
        let deltaX = 0;
        let deltaY = 0;
        if (lastClientX) {
          deltaX = e.e.clientX - lastClientX;
        }
        if (lastClientY) {
          deltaY = e.e.clientY - lastClientY;
        }

        let olddelta = new fabric.Point(e.e.clientX, e.e.clientY);
        let newdelta = new fabric.Point(deltaX, deltaY);

        // Update the last X and Y values
        lastClientX = e.e.clientX;
        lastClientY = e.e.clientY;

        this.relativePan(newdelta);
        this.trigger('moved');
        this.renderAll();
      }
    });
  } else {
    // When we exit dragmode, we restore the previous values on all objects
    this.forEachObject(function(object) {
      object.evented = (object.prevEvented !== undefined) ? object.prevEvented : object.evented;
      object.selectable = (object.prevSelectable !== undefined) ? object.prevSelectable : object.selectable;
    });
    // Reset the cursor
    this.defaultCursor = 'move';
    // Remove the event listeners
    this.off('mouse:up');
    this.off('mouse:down');
    this.off('mouse:move');
    // Restore selection ability on the canvas
    this.selection = true;
  }
};

export default FabricCanvas;


// WEBPACK FOOTER //
// ./src/components/FabricCanvas.js